export default __webpack_public_path__ + "static/panel-anatomy-light-063881f0ba4547235181b7986855db2c.png";